var exports = {
  "kL": "xaf9ae18d--40854b--container",
  "Qs": "xaf9ae18d--40854b--content",
  "nf": "xaf9ae18d--40854b--link",
  "Hw": "xaf9ae18d--40854b--mobile",
};

module.exports = exports;
